<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>New Schedule</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSave">

          <md-radio v-model="scheduleType" value="GENERAL">General</md-radio>
          <md-radio v-model="scheduleType" value="MK1">Milk Run 1</md-radio>
          <md-radio v-model="scheduleType" value="MK2">Milk Run 2</md-radio>

          <template v-if="scheduleType !== 'GENERAL'">
            <template v-if="scheduleType==='MK1'">
              <md-field :class="getValidationClass('dataForm.loadIdLinked')">
                <label>Load Id Linked</label>
                <md-input v-model="dataForm.loadIdLinked"/>
                <span class="md-error" v-if="!$v.dataForm.loadIdLinked.requiredIfMk1">Load Id is required</span>
              </md-field>
            </template>
            <template v-if="scheduleType==='MK2'">
              <div :class="getValidationClass('dataForm.storeId')">
                <master-data-select label="Transloading Location" group="EndOutletMilkRun2" v-model="dataForm.storeId"/>
                <span class="md-error" v-if="!$v.dataForm.storeId.requiredIfNotMk1">Transloading Location is required</span>
              </div>

              <div :class="getValidationClass('dataForm.storeId')">
                <master-data-select label="EndOutlet" group="EndOutlet" v-model="dataForm.endOutletId"/>
                <span class="md-error" v-if="!$v.dataForm.endOutletId.requiredIfMk2">End Outlet is required</span>
              </div>
            </template>
          </template>
          <md-field v-else :class="getValidationClass('dataForm.storeId')">
            <label>Store Id</label>
            <md-input v-model="dataForm.storeId"/>
            <span class="md-error" v-if="!$v.dataForm.storeId.required">Store Id is required</span>
          </md-field>

          <calling-api path="/api/w/users" type="bar">
            <div :class="getValidationClass('dataForm.etaPlan')" v-if="drivers">
              <auto-complete-master-data-select
                  display-type="idOnly"
                  label="Driver"
                  :prepared-options="drivers"
                  :on-item-changed="handleDriverChanged">
              </auto-complete-master-data-select>
              <span class="md-error" v-if="!$v.dataForm.driverId.required">Driver is required</span>
            </div>
          </calling-api>

          <div :class="getValidationClass('dataForm.etaPlan')">
            <datepicker v-model="dataForm.etaPlan">
              <label>Eta Plan</label>
            </datepicker>
            <span class="md-error" v-if="!$v.dataForm.etaPlan.required">ETA Plan is required</span>
          </div>

          <div :class="getValidationClass('dataForm.etaAssigned')">
            <datepicker v-model="dataForm.etaAssigned">
              <label>Eta Assigned</label>
            </datepicker>
            <span class="md-error" v-if="!$v.dataForm.etaAssigned.required">ETA Assigned is required</span>
            <span class="md-error" v-if="!$v.dataForm.etaAssigned.checkAfterEtaPlan">ETA Assigned should after eta plan</span>
          </div>

          <calling-api type="bar" path="/api/w/schedules/save">

            <md-dialog-actions>
              <md-button class="md-primary" @click="showDialog = false">Close</md-button>
              <md-button type="submit" class="md-primary">Save</md-button>
            </md-dialog-actions>

          </calling-api>


        </form>

      </md-dialog-content>
    </md-dialog>
  </div>

</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
  }
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import AutocompleteSearchableStoreMultipleSelect from "./AutocompleteSearchableStoreMultipleSelect";
  import { required, } from 'vuelidate/lib/validators';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialDataForm = () => {
    return {
      storeId: null,
      driverId: null,
      etaPlan: null,
      etaAssigned: null,
      loadIdLinked: null,
      endOutletId: null,
    }
  };


  export default {
    components: { AutocompleteSearchableStoreMultipleSelect },
    mixins: [validationMixin],
    data: () => ({
      showDialog: false,
      dataForm: getInitialDataForm(),
      drivers: null,
      scheduleType: 'GENERAL',
    }),
    watch: {
      scheduleType() {
        this.dataForm = getInitialDataForm();
      },
      showDialog(val) {
        if (val === false) {
          this.$store.commit('clearApiError');
        }
      },
    },
    validations: {
      dataForm: {
        storeId: {
          requiredIfNotMk1(val) {
            if (this.scheduleType === "MK1") {
              return true;
            }
            return !!val;
          },
        },
        loadIdLinked: {
          requiredIfMk1(val) {
            if (this.scheduleType !== "MK1") {
              return true;
            }
            return !!val;
          },
        },
        driverId: {
          required,
        },
        etaPlan: {
          required,
        },
        etaAssigned: {
          required,
          checkAfterEtaPlan(val) {
            if (!val) {
              return false;
            }
            return !moment(this.dataForm.etaPlan).isAfter(moment(val));
          },
        },
        endOutletId: {
          requiredIfMk2(val) {
            if (this.scheduleType !== "MK2") {
              return true;
            }
            return !!val;
          },
        },
      },
    },
    methods: {
      handleDriverChanged(id) {
        this.dataForm.driverId = id;
      },
      openDialog() {
        this.drivers = null;
        this.dataForm = getInitialDataForm();
        this.$v.dataForm.$reset();
        this.showDialog = true;

        this.$store.dispatch('getUsersByCategory', { category: 'A' }).then((res) => {
          this.drivers = res;
        });
      },
      getValidationClass(fieldName) {
        const field = _(this.$v).lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
        return {};
      },
      doSave() {
        this.$v.dataForm.$touch();
        console.log(this.$v.dataForm.$invalid);
        if (this.$v.dataForm.$invalid) {
          return;
        }

        const req = {
          action: 'FIRST_WEEK',
          storeId: this.dataForm.storeId,
          driverId: this.dataForm.driverId,
          etaPlan: this.dataForm.etaPlan,
          etaAssigned: this.dataForm.etaAssigned,
          loadIdLinked: this.dataForm.loadIdLinked,
          endOutletId: this.dataForm.endOutletId,
        };

        console.log(JSON.stringify(req));

        //api.post("/api/w/schedules/save", [req])
        newAPIPost("/api/w/schedules/save", [req])
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            $('.btn-search-schedule').click();
          });
      },
    },
  }


</script>
